import React, { useState, useEffect, useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import { useUser } from '../contexts/UserContext';
import ZLogo from './ZLogo';

const navItems = [
  { path: '/', label: 'Home' },
  { path: '/institutions', label: 'Institutions' },
  { path: '/financial-institutions', label: 'Funding' },
  { path: '/dashboard', label: 'Dashboard' },
  { path: '/career-suggester', label: 'Careers' },
  { path: '/profile', label: 'Profile' },
  { path: '/learn-more', label: 'Learn More' },

];

/**
 * A header component that provides navigation links and a login/logout button.
 *
 * The navbar is a horizontal bar with a fixed position at the top of the page.
 * It contains a logo (Zazi) on the left and nav links on the right.
 * The nav links are styled as buttons and change color on hover.
 * The login/logout button is on the right side of the navbar and changes color
 * depending on whether the user is logged in or not.
 *
 * @returns A JSX element representing the navbar.
 */
function Navbar() {
  const location = useLocation();
  const { user } = useUser();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(getAuth());
    navigate('/auth');
  };

  const handleLogin = () => {
    navigate('/auth');
  };

  return (
    <header style={{
      width: '100%',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 100,
      background: 'linear-gradient(90deg, #1e3c72 0%, #2a5298 100%)',
      boxShadow: '0 2px 8px #0002',
      display: 'flex',
      alignItems: 'center',
      padding: '0 32px',
      height: 64,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 28, flex: 1 }}>
        {/* Nav Links */}
        {/* Nav Links */}
        <nav style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={location.pathname === item.path ? 'nav-link active' : 'nav-link'}
              style={{
                fontWeight: location.pathname === item.path ? 700 : 500,
                fontSize: 16,
                color: '#fff',
                background: location.pathname === item.path ? 'rgba(255,255,255,0.14)' : 'transparent',
                textDecoration: 'none',
                padding: '10px 18px',
                borderRadius: 8,
                transition: 'color 0.2s, background 0.2s',
              }}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>
      {/* Auth Button Right */}
      <div style={{ marginRight: 48 }}>
        {user ? (
          <button onClick={handleLogout} style={{
            background: '#fff', color: '#1e3c72', fontWeight: 700, border: 'none', borderRadius: 8, padding: '8px 20px', fontSize: 16, boxShadow: '0 1px 4px #0001', cursor: 'pointer', transition: 'background 0.2s, color 0.2s', marginLeft: 18
          }}>Logout</button>
        ) : (
          <button onClick={handleLogin} style={{
            background: '#fff', color: '#1e3c72', fontWeight: 700, border: 'none', borderRadius: 8, padding: '8px 20px', fontSize: 16, boxShadow: '0 1px 4px #0001', cursor: 'pointer', transition: 'background 0.2s, color 0.2s', marginLeft: 18
          }}>Login</button>
        )}
      </div>
          </header>
  );
}

export default Navbar;
